import { useEffect, useState } from 'react';
import { useApolloClient, useQuery } from '@apollo/react-hooks';
import { pathOr } from 'ramda';
import gql from 'graphql-tag';

type SelectedPlaces = {
  selectedPlaces: string[] | null;
};

const GET_SELECTED_PLACES_DATA = gql`
  {
    selectedPlaces @client
  }
`;

type SelectedPlacesData = {
  data: SelectedPlaces;
};

export const useSelectedPlaces = () => {
  const [selectedPlaces, setSelectedPlaces] = useState<string[]>([]);
  const client = useApolloClient();

  // initialize cache
  useEffect(() => {
    writeSelectedPlacesCache({
      data: {
        selectedPlaces: [],
      },
    });
  }, []);

  const { data: selectedPlacesData = [] } = useQuery<SelectedPlaces>(
    GET_SELECTED_PLACES_DATA,
  );

  useEffect(() => {
    const selectedPlaces = ([] = pathOr(
      [],
      ['selectedPlaces'],
      selectedPlacesData,
    ));
    setSelectedPlaces(selectedPlaces);
  }, [selectedPlacesData]);

  const writeSelectedPlacesCache = (data: SelectedPlacesData) => {
    client.writeData(data);
  };

  return {
    writeSelectedPlacesCache,
    selectedPlaces,
  };
};
